import $ from "jquery";

export default class ResetableInput {
  constructor(input) {
    this.input = input;
    this.resetButton = $("<div class='reset-button'><i class='fa fa-times'></i></div>");
    this.input.wrap("<div style='position:relative'></div>").parent().append(this.resetButton);
    this.input.on("input", this.inputChanged.bind(this));
    this.resetButton.on("click", this.resetButtonClicked.bind(this));
    this.inputChanged();
  }

  showOrHideResetButton() {
    this.input.val() == ""
      ? this.resetButton.hide()
      : this.resetButton.show();
  }

  resetButtonClicked() {
    this.input.val("").trigger("input");
    this.showOrHideResetButton();
    this.input.focus();
  }

  inputChanged() {
    this.showOrHideResetButton();
  }
}
